module.exports = __webpack_public_path__ + "img/tiktok.1ca86745.svg";